export { settingsModuleName as moduleName } from '@shared/constants';

export const devices = Object.freeze({
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
});
